import EmptyList from '@/components/Common/EmptyList';
import ConnectionNotesListItem from './ConnectionNotesListItem';

// @vue/component
export default {
  name: 'ConnectionNotesList',

  components: {
    EmptyList,
    ConnectionNotesListItem,
  },

  props: {
    connectionId: {
      type: Number,
      default: null,
    },
  },

  computed: {
    isLoading() {
      return this.$store.getters['app/pendingStoreActions'].includes([
        'connections/notes/getList',
        'connections/notes/create',
      ]);
    },
    notesList() {
      return this.$store.getters['connections/notes/list'];
    },
    isEmpty() {
      return this.notesList.length === 0;
    },
  },

  created() {
    if (this.connectionId) {
      this.$store.dispatch('connections/notes/getList', this.connectionId);
    }
  },

};
